<template>
  <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100 font-sans">
    <div class="bg-white p-8 rounded shadow-md w-full max-w-4xl md:max-w-xl md:w-9/10">
      <!-- Encabezado con menú -->
      <div class="flex items-center justify-between mb-6 border-b pb-4 border-gray-200">
        <h2 class="text-3xl font-semibold text-gray-800 tracking-tight">
          {{ companyName || "Welcome to the Dashboard!" }}
          <br>
          <span class="text-base text-blue-800">Applicant Tracking System by Interbot</span>
        </h2>
        <div class="relative" @click="toggleMenu">
          <button
            class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 flex items-center transition-colors duration-200"
          >
            Menu
            <svg class="w-4 h-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div v-if="isMenuOpen" class="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-xl z-10">
            <router-link  :to="{ name: 'JobDescription' }" class="block py-2 px-4 text-gray-700 hover:bg-gray-100 cursor-pointer">
                Asistente descripción de puesto
            </router-link>
            <router-link  :to="{ name: 'create-vacancy' }" class="block py-2 px-4 text-gray-700 hover:bg-gray-100 cursor-pointer">
                Crear nueva vacante
            </router-link>
            <!--
            <a @click="createCandidate" class="block py-2 px-4 text-gray-700 hover:bg-gray-100 cursor-pointer">
              Crear Candidato
            </a>
            <a @click="assignInterview" class="block py-2 px-4 text-gray-700 hover:bg-gray-100 cursor-pointer">
              Asignar Entrevista
            </a>
            -->
             <hr class="border-gray-200 my-1" />
             <a @click="logout" class="block py-2 px-4 text-gray-700 hover:bg-gray-100 cursor-pointer">
                Salir
            </a>
          </div>
        </div>
      </div>

      

      <!-- Info del usuario -->
      <div class="mb-6 text-left border-b pb-4 border-gray-200">
        <p class="text-gray-600" v-if="user">
          Usuario activo: {{ user.email }}
        </p>
      </div>

      <!-- Indicador de carga o error -->
      <div v-if="isLoading" class="text-gray-600 text-center py-4">
        Cargando...
      </div>
      <div v-if="fetchError" class="mt-4 text-red-500 text-center py-4">
        {{ fetchError }}
      </div>

      <!-- Seccion de Vacantes -->
       <div v-if="vacancies.length > 0">
          <h3 class="text-xl font-semibold text-gray-700 mb-4 mt-6 border-b pb-2 border-gray-200 flex justify-between items-center">
               <span>Vacantes Activas <span class="font-normal text-gray-500">({{ activeVacancies.length }})</span></span>
           </h3>
        <div v-for="vacancy in activeVacancies" :key="vacancy.id" class="mb-4">
          <div
            @click="toggleAccordion(vacancy.id)"
            class="p-4 rounded bg-gray-100 cursor-pointer flex items-center justify-between hover:bg-gray-200 transition-colors duration-200"
          >
            <p class="font-semibold text-gray-700">{{ vacancy.title }}
                 <span class="text-sm text-gray-500 ml-2">({{ vacancy.applications.length }} apps, {{ vacancy.applications.reduce((acc, app) => acc + (app.interviews ? app.interviews.length : 0), 0) }} intvs)</span></p>
            <div class="flex items-center">

            <svg
              :class="{ 'rotate-180': openAccordion === vacancy.id }"
              class="w-4 h-4 text-gray-600 transform transition-transform duration-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
              </div>
          </div>
          <div
            v-if="openAccordion === vacancy.id"
            class="p-4 mt-2 rounded bg-gray-50 flex flex-col"
          >
              <div class="flex justify-between items-start mb-2">
                <a :href="`https://interbot.mx/job/${vacancy.id}`" class="text-gray-600 underline hover:text-blue-700" target="_blank" rel="noopener noreferrer">
     https://interbot.mx/job/{{ vacancy.id }}
    </a>
              <button @click.stop="openEditModal(vacancy)" class="ml-2">
                 <svg class="w-4 h-4 text-gray-500 hover:text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L15.232 5.232z" />
                    </svg>
                </button>
            </div>
             <div v-if="vacancy.applications.length > 0">
                 <h4 class="text-lg font-semibold text-gray-700 mb-2">Candidatos</h4>

                 <div v-for="application in sortApplications(vacancy.applications)" :key="application.id" class="p-3 rounded bg-gray-100 mb-2">
        <div class="flex items-center justify-between mb-2">
            <p class="font-semibold text-gray-700 cursor-pointer text-blue-500 hover:text-blue-700 underline" @click="openCandidateModal(application)">
                 {{ application.name }}
             </p>
            <div class="flex flex-col items-center">
                <button @click="openStatusModal(application)" class="flex items-center">
                    <span v-if="application.status === 'Nueva'"> 📩 </span>
                    <span v-if="application.status === 'Entrevista'"> 💬 </span>
                    <span v-if="application.status === 'Evaluar'"> 📊 </span>
                    <span v-if="application.status === 'Reclutador'"> 📅 </span>
                   <span v-if="application.status === 'Proceso'"> 📝 </span>
                    <span v-if="application.status === 'Seleccionado'"> 🏆 </span>
                   <span v-if="application.status === 'Descartado'"> ❌ </span>
                </button>
                  <button v-if="application.status === 'Evaluar' || application.status === 'Reclutador' || application.status === 'Proceso' || application.status === 'Descartado'"
                        @click="openAnalysis(application)"
                       class="text-gray-600 hover:text-gray-800 focus:outline-none mt-1"
                        >
                       <span > 🗂️ </span>
                    </button>
                </div>
        </div>
        <div v-if="application.status === 'Nueva'">
            <button
                @click="startInterbotInterview(application)"
                :disabled="interbotInterviewButtonsDisabled[application.id]"
                class="bg-green-500 hover:bg-green-600 text-white py-1 px-3 rounded focus:outline-none focus:ring-2 focus:ring-green-400 transition-colors duration-200"
            >
            <span v-if="interbotInterviewButtonsDisabled[application.id]">Asignando Entrevista...</span>
            <span v-else>Entrevistar con Interbot</span>
            </button>
         </div>
         <div v-if="application.status === 'Entrevista'">
          <p class="text-gray-600">Entrevista asignada:</p>
          <a v-if="application.interviewId"
            :href="`https://interbot.mx/interbot?code=${application.interviewId._path.segments[1]}`"
            class="text-gray-600 underline hover:text-blue-700"
            target="_blank"
            rel="noopener noreferrer"
            >
              https://interbot.mx/interbot?code={{ application.interviewId._path.segments[1] }}
        </a>
           <p>
            @ {{ new Date(application.createdAt?._seconds * 1000).toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) }} 
           </p>
        </div>
        <div v-if="application.status === 'Evaluar' || application.status === 'Reclutador' || application.status === 'Proceso' || application.status === 'Descartado'">
              <div v-if="application.statusHistory && application.statusHistory.length > 0" class="mt-2">
                <p class="text-gray-600">
                    {{ application.statusHistory[application.statusHistory.length - 1]?.notes }}
                </p>
                  <p class="text-gray-600">
                    {{ new Date(application.statusHistory[application.statusHistory.length - 1]?.date._seconds * 1000).toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) }}
                </p>
              </div>
       </div>
       <div v-if="application.status === 'Seleccionado'">
           <button
                @click="openContactModal(application)"
                class="bg-blue-500 hover:bg-blue-600 text-white py-1 px-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200"
            >
            Contactar Candidato
           </button>
        </div>
    </div>

             </div>
              <div v-else>
                 <p class="text-gray-600">No hay candidatos para esta vacante.</p>
              </div>
          </div>
        </div>
         <h3  @click="toggleInactiveVacancies" class="text-xl font-semibold text-gray-700 mb-4 mt-6 border-b pb-2 border-gray-200 cursor-pointer flex justify-between items-center">
                <span>Vacantes Inactivas
                <span class="font-normal text-gray-500">({{ inactiveVacancies.length }})</span></span>
                  <svg
                    :class="{ 'rotate-180': inactiveVacanciesOpen }"
                    class="w-4 h-4 text-gray-600 transform transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                     viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                 >
                    <path
                       stroke-linecap="round"
                    stroke-linejoin="round"
                     stroke-width="2"
                     d="M19 9l-7 7-7-7"
                 />
                   </svg>
          </h3>
        <div v-if="inactiveVacanciesOpen">
           <div v-for="vacancy in inactiveVacancies" :key="vacancy.id" class="mb-4">
          <div
            @click="toggleAccordion(vacancy.id)"
            class="p-4 rounded bg-gray-100 cursor-pointer flex items-center justify-between hover:bg-gray-200 transition-colors duration-200"
          >
            <p class="font-semibold text-gray-700">{{ vacancy.title }}
                 <span class="text-sm text-gray-500 ml-2">({{ vacancy.applications.length }} apps, {{ vacancy.applications.reduce((acc, app) => acc + (app.interviews ? app.interviews.length : 0), 0) }} intvs)</span></p>
             <div class="flex items-center">


              </div>
              <svg
              :class="{ 'rotate-180': openAccordion === vacancy.id }"
              class="w-4 h-4 text-gray-600 transform transition-transform duration-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
          <div
            v-if="openAccordion === vacancy.id"
            class="p-4 mt-2 rounded bg-gray-50 flex flex-col"
          >
              <div class="flex justify-between items-start mb-2">
               <p class="text-gray-600 ">{{ vacancy.description }}</p>
              <button @click.stop="openEditModal(vacancy)" class="ml-2">
                 <svg class="w-4 h-4 text-gray-500 hover:text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L15.232 5.232z" />
                    </svg>
                </button>
            </div>
             <div v-if="vacancy.applications.length > 0">
                 <h4 class="text-lg font-semibold text-gray-700 mb-2">Candidatos</h4>
                 <div v-for="application in sortApplications(vacancy.applications)" :key="application.id" class="p-3 rounded bg-gray-100 mb-2">
                     <p class="font-semibold text-gray-700 cursor-pointer text-blue-500 hover:text-blue-700 underline" @click="openCandidateModal(application)">
                          {{ application.candidate?.name }}
                     </p>
                    <p class="text-gray-600">Email: {{ application.candidate?.email }}</p>
                   <div v-if="application.interviews.length > 0">
                      <h5 class="text-md font-semibold text-gray-700 mt-2 mb-1">Interviews</h5>
                         <div v-for="interview in application.interviews" :key="interview.id" class="p-2 rounded bg-gray-200 mb-1">
                          <div v-if="interview.status !== 'Not Started'">  
                            <p class="text-gray-600">
                                 <span class="cursor-pointer hover:underline" @click="openInterviewModal(interview)">
                                        {{ new Date(interview.interviewDate._seconds * 1000).toLocaleString() }}
                                    </span>
                                   <span> - Score: {{ interview.score }}</span>
                              </p>
                              <p>{{ interview.overall }} </p>
                              </div>
                              <div v-else>
                                Asignada el {{ new Date(interview.createdAt._seconds * 1000).toLocaleString() }}.
                              </div>
                             </div>
                    </div>
                    <div v-else>
                       <p class="text-gray-600 mt-2">No hay entrevistas para este candidato.</p>
                    </div>
                </div>
             </div>
              <div v-else>
                 <p class="text-gray-600">No hay candidatos para esta vacante.</p>
              </div>
          </div>
        </div>

      </div>

           <h3 @click="toggleClosedVacancies" class="text-xl font-semibold text-gray-700 mb-4 mt-6 border-b pb-2 border-gray-200 cursor-pointer flex justify-between items-center">
                <span>Vacantes Cerradas
                 <span class="font-normal text-gray-500">({{ closedVacancies.length }})</span></span>
                 <svg
                    :class="{ 'rotate-180': closedVacanciesOpen }"
                    class="w-4 h-4 text-gray-600 transform transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                     viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                 >
                    <path
                       stroke-linecap="round"
                    stroke-linejoin="round"
                     stroke-width="2"
                     d="M19 9l-7 7-7-7"
                 />
                   </svg>
            </h3>
         <div v-if="closedVacanciesOpen">
             <div v-for="vacancy in closedVacancies" :key="vacancy.id" class="mb-4">
          <div
            @click="toggleAccordion(vacancy.id)"
            class="p-4 rounded bg-gray-100 cursor-pointer flex items-center justify-between hover:bg-gray-200 transition-colors duration-200"
          >
            <p class="font-semibold text-gray-700">{{ vacancy.title }}
                 <span class="text-sm text-gray-500 ml-2">({{ vacancy.applications.length }} apps, {{ vacancy.applications.reduce((acc, app) => acc + (app.interviews ? app.interviews.length : 0), 0) }} intvs)</span></p>
            <div class="flex items-center">

             <svg
              :class="{ 'rotate-180': openAccordion === vacancy.id }"
              class="w-4 h-4 text-gray-600 transform transition-transform duration-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
             </div>
          </div>
          <div
            v-if="openAccordion === vacancy.id"
            class="p-4 mt-2 rounded bg-gray-50 flex flex-col"
          >
              <div class="flex justify-between items-start mb-2">
               <p class="text-gray-600 ">{{ vacancy.description }}</p>
              <button @click.stop="openEditModal(vacancy)" class="ml-2">
                 <svg class="w-4 h-4 text-gray-500 hover:text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L15.232 5.232z" />
                    </svg>
                </button>
            </div>
             <div v-if="vacancy.applications.length > 0">
                 <h4 class="text-lg font-semibold text-gray-700 mb-2">Candidatos</h4>
                 <div v-for="application in sortApplications(vacancy.applications)" :key="application.id" class="p-3 rounded bg-gray-100 mb-2">
                     <p class="font-semibold text-gray-700 cursor-pointer text-blue-500 hover:text-blue-700 underline" @click="openCandidateModal(application)">
                          {{ application.candidate?.name }}
                     </p>
                    <p class="text-gray-600">Email: {{ application.candidate?.email }}</p>
                   <div v-if="application.interviews.length > 0">
                      <h5 class="text-md font-semibold text-gray-700 mt-2 mb-1">Interviews</h5>
                         <div v-for="interview in application.interviews" :key="interview.id" class="p-2 rounded bg-gray-200 mb-1">
                          <div v-if="interview.status !== 'Not Started'">  
                            <p class="text-gray-600">
                                 <span class="cursor-pointer hover:underline" @click="openInterviewModal(interview)">
                                        {{ new Date(interview.interviewDate._seconds * 1000).toLocaleString() }}
                                    </span>
                                   <span> - Score: {{ interview.score }}</span>
                              </p>
                              <p>{{ interview.overall }} </p>
                              </div>
                              <div v-else>
                                Asignada el {{ new Date(interview.createdAt._seconds * 1000).toLocaleString() }}.
                              </div>
                             </div>
                    </div>
                    <div v-else>
                       <p class="text-gray-600 mt-2">No hay entrevistas para este candidato.</p>
                    </div>
                </div>
             </div>
              <div v-else>
                 <p class="text-gray-600">No hay candidatos a esta vacante.</p>
              </div>
          </div>
        </div>
        </div>
      </div>

      <!-- Mensaje si no hay vacantes -->
      <div v-else-if="!isLoading && !fetchError">
        <p class="text-gray-600 text-center py-4">No hay vacantes ahora.</p>
      </div>

      <!-- Modales -->
      <candidate-modal
        :is-open="isCandidateModalOpen"
        :application="selectedApplication"
        @close="closeCandidateModal"
      />
      <interview-modal
        :is-open="isInterviewModalOpen"
        :interview="selectedInterview"
        @close="closeInterviewModal"
      />
       <edit-vacancy-modal
              v-if="isEditModalOpen"
              :vacancy="selectedVacancy"
              @close="closeEditModal"
              @vacancy-updated="fetchData"
            />
         <status-modal
              :is-open="isStatusModalOpen"
              :application="selectedApplication"
              @close="closeStatusModal"
                @status-updated="fetchData"
             />
         <contact-modal
          :is-open="isContactModalOpen"
          :application="selectedApplication"
          @close="closeContactModal"
        />
    </div>
  </div>
</template>

<script>
import AuthService from "@/services/auth.service";
import { auth } from "@/firebase";
import { signInWithCustomToken } from "firebase/auth";
import CandidateModal from '@/components/CandidateModal.vue';
 import InterviewModal from '@/components/InterviewModal.vue';
 import EditVacancyModal from '@/components/EditVacancyModal.vue';
 import StatusModal from '@/components/StatusModal.vue';
  import ContactModal from '@/components/ContactModal.vue';


async function getCustomTokenFromBackend(firebaseIdToken) {
  try {
    const response = await fetch("/api/get-custom-token", {
      // Replace with your backend URL
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ firebaseIdToken }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `Failed to fetch custom token: ${response.status} ${JSON.stringify(
          errorData
        )}`
      );
    }
    const data = await response.json();
    if (!data.customToken) {
      throw new Error(
        `Failed to fetch custom token, missing token ${JSON.stringify(data)}`
      );
    }
    return data.customToken;
  } catch (error) {
    console.error("Error getting the custom token:", error);
    throw error;
  }
}

export default {
    components: {
      CandidateModal,
      InterviewModal,
      EditVacancyModal,
      StatusModal,
      ContactModal
    },
  data() {
    return {
      user: null,
      companyName: null,
      vacancies: [],
      fetchError: null,
      isLoading: false,
        openAccordion: null,
        isCandidateModalOpen: false,
        selectedCandidate: null,
        selectedApplication: null,
          isInterviewModalOpen: false,
         selectedInterview: null,
         isMenuOpen: false,
         isEditModalOpen: false,
         selectedVacancy: null,
           activeVacancies: [],
          inactiveVacancies: [],
           closedVacancies: [],
          inactiveVacanciesOpen: false,
         closedVacanciesOpen: false,
         isInterbotModalOpen: false,
         interbotInterviewId: null,
          interbotInterviewButtonsDisabled: {}, // <-- Add this line
          isStatusModalOpen: false,
         isContactModalOpen: false,

    };
  },
  async created() {
    this.user = await AuthService.getCurrentUser();
     await this.fetchData();
  },
  methods: {
    sortApplications(applications) {
        const statusOrder = {
            'Seleccionado': 1,
           'Proceso': 2,
           'Reclutador': 3,
             'Evaluar': 4,
               'Entrevista': 5,
           'Nueva': 6,
            'Descartado': 7,
         };
         return [...applications].sort((a, b) => {
            const statusA = a.status || 'Nueva';
            const statusB = b.status || 'Nueva';
            return (statusOrder[statusA] || 7) - (statusOrder[statusB] || 7);
         });
       },
    openContactModal(application) {
            this.selectedApplication = application;
            this.isContactModalOpen = true;
        },
      closeContactModal() {
          this.selectedApplication = null;
         this.isContactModalOpen = false;
      },
       openStatusModal(application) {
            this.selectedApplication = application;
            this.isStatusModalOpen = true;
        },
      closeStatusModal() {
            this.selectedApplication = null;
            this.isStatusModalOpen = false;
        },
      async openAnalysis(application){
            try{
               const interviewIdRef = application.interviewId //|| (application.interviews && application.interviews.length > 0 ? application.interviews[0].id : null); // Obtener el interviewId de diferentes lugares
               const interviewId = interviewIdRef?._path?.segments[1] 
               if (interviewId) {
                   this.$router.push({ path: `/analysis`, query: { code: interviewId } });
                 } else {
                    alert("No se encontró el ID de la entrevista digital")
                 }
               }
              catch(error){
                  console.error("Error al obtener el interviewID", error);
                   alert("Error al obtener el interviewID")
              }
        },
    isInterbotInterviewButtonDisabled(applicationId) {
        return this.interbotInterviewButtonsDisabled[applicationId] || false;
    },
        async startInterbotInterview(application) {
          try {
              this.interbotInterviewButtonsDisabled[application.id] = true;
              this.fetchError = null;

              const response = await fetch('/api/start-interbot-interview', {
                 method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                 },
               body: JSON.stringify({
                    applicationId: application.id,
                    candidateId: application.candidateId,
                     vacancyId: application.vacancyId
                 }),
             });

              if (!response.ok) {
                   const errorData = await response.json();
                  throw new Error(
                    `Failed to create Interbot interview: ${response.status} ${JSON.stringify(errorData)}`
                  );
                }

                const data = await response.json();
                  this.interbotInterviewId = data.interviewId;
                 this.isInterbotModalOpen = true;

          } catch (error) {
               this.fetchError = `Failed to create Interbot interview: ${error.message}`;
          } finally {
             this.interbotInterviewButtonsDisabled[application.id] = false;
             await this.fetchData();
          }
    },
        closeInterbotModal(){
          this.interbotInterviewId = null;
           this.isInterbotModalOpen = false;
        },
      toggleMenu() {
          this.isMenuOpen = !this.isMenuOpen;
      },
      toggleInactiveVacancies() {
         this.inactiveVacanciesOpen = !this.inactiveVacanciesOpen;
      },
        toggleClosedVacancies() {
          this.closedVacanciesOpen = !this.closedVacanciesOpen;
       },
       openEditModal(vacancy) {
           this.selectedVacancy = { ...vacancy };
            this.isEditModalOpen = true;
         },
      closeEditModal() {
          this.selectedVacancy = null;
            this.isEditModalOpen = false;
        },
      createVacancy(){
          this.toggleMenu();
          // alert("Create Vacancy");
          this.$router.push({ name: 'create-vacancy'});
      },
      createCandidate(){
             this.toggleMenu();
           alert("Create Candidate");
       },
       assignInterview(){
            this.toggleMenu();
           alert("Assign Interview");
        },
      openInterviewModal(interview){
            this.selectedInterview = interview;
           this.isInterviewModalOpen = true;
      },
       closeInterviewModal(){
         this.selectedInterview = null;
          this.isInterviewModalOpen = false;
      },
      openCandidateModal(application){
           console.log(application);
           this.selectedApplication = application;
           this.isCandidateModalOpen = true;
      },
       closeCandidateModal(){
         this.selectedApplication = null;
          this.isCandidateModalOpen = false;
      },
      toggleAccordion(vacancyId) {
          this.openAccordion = this.openAccordion === vacancyId ? null : vacancyId;
      },
    async fetchData() {
      this.isLoading = true;
      this.fetchError = null;
      try {
        // 1. Get the Firebase ID token (original)
        const firebaseIdToken = await auth.currentUser.getIdToken();

        // 2. Get the custom token from backend
        const customToken = await getCustomTokenFromBackend(firebaseIdToken);

        // 3. Authenticate with custom token using signInWithCustomToken
        await signInWithCustomToken(auth, customToken);

        // 4. Get the token to use in the Authorization header (use firebase.auth().currentUser.getIdToken())
        const token = await auth.currentUser.getIdToken();

           // Fetch Company Info (name)
          const companyResponse = await fetch("/api/company-names", {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });

            if (!companyResponse.ok) {
              throw new Error(
                `HTTP error! status: ${companyResponse.status}`
              );
            }
           const companyData = await companyResponse.json();

           this.companyName = companyData[0]?.name;


        // Fetch vacancies
        const vacanciesResponse = await fetch("/api/vacancies", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

         if (!vacanciesResponse.ok) {
          throw new Error(
            `HTTP error! status: ${vacanciesResponse.status}`
          );
        }

        const allVacancies = await vacanciesResponse.json();
         this.activeVacancies = allVacancies
           .filter(v => (v.status || 'No Activa') === 'Activa')
            .sort((a,b) => (b.createdAt?._seconds || 0) - (a.createdAt?._seconds || 0));
         this.inactiveVacancies = allVacancies
            .filter(v => (v.status || 'No Activa') === 'No Activa')
             .sort((a,b) => (b.createdAt?._seconds || 0) - (a.createdAt?._seconds || 0));
         this.closedVacancies = allVacancies
             .filter(v => (v.status || 'No Activa') === 'Cerrada')
             .sort((a,b) => (b.createdAt?._seconds || 0) - (a.createdAt?._seconds || 0));


          this.vacancies = allVacancies;
          console.log(allVacancies);
      } catch (error) {
        this.fetchError = error.message;
         this.vacancies = [];
         this.companyName = null;
         this.activeVacancies = [];
          this.inactiveVacancies = [];
        this.closedVacancies= [];
      } finally {
        this.isLoading = false;
      }
    },
    async logout() {
      await AuthService.signOutUser();
      this.$router.push("/login");
    },
  },
};
</script>